<template>
    <div>
        <PullContainer ref="pullContainerRef"  :pullDownLoading="true" :pullDownLabel="true" @pullDownLoadingSuccess="pullDownLoadingSuccess">
            <template #container>
                <div class="public_container" v-loading="loading">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

                        </ReturnNavBar>
                        <div class="mobile_head_operate" >
                            <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                                <ul class="head_operate_popover_list">
                                    <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">
                                        <i :class="item.icon"></i> <span v-text="item.text"></span>
                                    </li>
                                </ul>
                                <template #reference>
                                    <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                                </template>
                            </van-popover>
                        </div>
                    </div>
                    <div class="inventory_pending_container mobile_container">
                        <div class="inventory_pending_top">
                            <div class="mobile_search_tab">
                                <div class="left mobile_search_tab_nav">
                                    <ul>
                                        <li @click="handleClickTabNav(item)" :class="tabNavActive == item.value ? 'active' : ''" v-for="item in tab_nav_list" v-text="item.name"></li>
                                    </ul>
                                </div>
                                <div class="right">
                                    <div class="box">
                                        <span @click="handleClickShowType('card')" :class="showType == 'card' ? 'active' : ''">卡片</span>
                                        <span @click="handleClickShowType('table')" :class="showType == 'table' ? 'active' : ''">表格</span>
                                    </div>
                                </div>
                            </div>
                            <div class="mobile_search_tab" v-if="tabNavActive == 'need'">
                                <div class="left">
                                    <ul>
                                        <li :class="tabNavChildActive == 'all' ? 'active':''" @click="handleClickTabNavChild('all')"> 全部</li>
                                        <li :class="tabNavChildActive == 'in' ? 'active':''"  @click="handleClickTabNavChild('in')">入库</li>
                                        <li :class="tabNavChildActive == 'out' ? 'active':''" @click="handleClickTabNavChild('out')">出库</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="mobile_search_input">
                                <van-search
                                        v-model="searchForm.keyword"
                                        placeholder="请输入查询内容"
                                        @clear="handleClickSearch"
                                        @search="handleClickSearch">
                                    <template #right-icon>
                                        <i class="iconfont icon-shaixuan" @click="searchPopupShow = true"></i>
                                        <i class="iconfont icon-tuodong" @click="sortRadioPicker = true"></i>
                                    </template>
                                </van-search>
                            </div>
                        </div>
                        <div class="inventory_pending_bottom" ref="inventory_pending_bottom" >
                            <!--卡片-->
                            <template v-if="showType == 'card'">
                                <div class="inventory_pending_card">
                                    <ul :class="'inventory_pending_card_' + tabNavActive" v-infinite-scroll="onLoadList">
                                        <!--待办-->
                                        <template v-if="tabNavActive == 'need'">
                                            <li :class="item.type =='in' ? 'inventory_pending_in' : 'inventory_pending_out'" v-for="(item,index) in tableData" :key="index" @click="handleClickPending(item)">
                                                <div class="top">
                                                    <div class="title ellipsis" v-text="item.approval_set_name">入库类型</div>
                                                    <div class="status_code" v-if="item.type =='in'">
                                                        <span class="status_code_text status_code0"  v-if="item.status == 0 ">待入库</span>
                                                        <span class="status_code_text status_code1"  v-if="item.status == 1 ">已取消</span>
                                                        <span class="status_code_text status_code2"  v-if="item.status == 2 ">部分入库</span>
                                                        <span class="status_code_text status_code3"  v-if="item.status == 3 ">全部入库</span>
                                                        <van-icon name="arrow" />
                                                    </div>
                                                    <div class="status_code" v-else>
                                                        <span class="status_code_text status_code0"  v-if="item.status == 0 ">待出库</span>
                                                        <span class="status_code_text status_code1"  v-if="item.status == 1 ">已取消</span>
                                                        <span class="status_code_text status_code2"  v-if="item.status == 2 ">部分出库</span>
                                                        <span class="status_code_text status_code3"  v-if="item.status == 3 ">全部出库</span>
                                                        <van-icon name="arrow" />
                                                    </div>
                                                </div>
                                                <div class="bottom">
                                                    <div class="user_info ellipsis" v-if="item.creator_info" @click.stop="handleClickUserDetail(item.creator_info.id)">
                                                        <img :src="item.creator_info.avatar ? item.creator_info.avatar : defaultImg" alt="" />
                                                        <span v-text="item.creator_info.name"></span>
                                                    </div>
                                                    <div class="time ellipsis" v-text="item.created_at"></div>
                                                </div>
                                            </li>

                                        </template>
                                        <!--已完成-->
                                        <template v-if="tabNavActive == 'completed'">
                                            <li  :class="item.type =='in' ? 'inventory_pending_in' : 'inventory_pending_out'" v-for="(item,index) in tableData" :key="index"  @click="handleClickDetail(item)">
                                                <div class="top">
                                                    <div class="title ellipsis" v-text="item.approval_set_name">入库类型</div>
                                                    <div class="status_code">
                                                        <van-icon name="arrow"/>
                                                    </div>
                                                </div>
                                                <div class="bottom">
                                                    <div class="field_list_item">
                                                        <div class="field_name">发起人：</div>
                                                        <div class="field_value">
                                                            <div class="user_info ellipsis" v-if="item.approval_user" @click.stop="handleClickUserDetail(item.approval_user.id)">
                                                                <img :src="item.approval_user.avatar ? item.approval_user.avatar : defaultImg" alt="" />
                                                                <span v-text="item.approval_user.name"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="field_list_item">
                                                        <div class="field_name">业务编号：</div>
                                                        <div class="field_value">
                                                            <span v-if="item.related_info && item.related_info.related_num" class="link-label" @click.stop="handleClickRelatedDetail(item)" v-text="item.related_info.related_num"></span>
                                                            <span v-else>--</span>
                                                        </div>
                                                    </div>
                                                    <div class="field_list_item">
                                                        <div class="field_name">处理人：</div>
                                                        <div class="field_value">
                                                            <div class="user_info ellipsis" v-if="item.creator_info" @click.stop="handleClickUserDetail(item.creator_info.id)">
                                                                <img :src="item.creator_info.avatar ? item.creator_info.avatar : defaultImg" alt="" />
                                                                <span v-text="item.creator_info.name"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="field_list_item">
                                                        <div class="field_name">单据日期：</div>
                                                        <div class="field_value">
                                                            <span v-text="item.created_at"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </template>
                                        <!--已取消-->
                                        <template v-if="tabNavActive == 'cancelled'">
                                            <li :class="item.type =='in' ? 'inventory_pending_in' : 'inventory_pending_out'" v-for="(item,index) in tableData" :key="index"  @click="handleClickCancelDetail(item)">
                                                <div class="top">
                                                    <div class="title ellipsis" v-text="item.approval_set_name"></div>
                                                    <div class="status_code">
                                                        <van-icon name="arrow" />
                                                    </div>
                                                </div>
                                                <div class="bottom">
                                                    <div class="field_list_item">
                                                        <div class="field_name">发起人：</div>
                                                        <div class="field_value">
                                                            <div class="user_info ellipsis" v-if="item.creator_info" @click.stop="handleClickUserDetail(item.creator_info.id)">
                                                                <img :src="item.creator_info.avatar ? item.creator_info.avatar : defaultImg" alt="" />
                                                                <span v-text="item.creator_info.name"></span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="field_list_item">
                                                        <div class="field_name">处理人：</div>
                                                        <div class="field_value">
                                                            <div class="user_info ellipsis" v-if="item.cancel_info" @click.stop="handleClickUserDetail(item.cancel_info.id)">
                                                                <img :src="item.cancel_info.avatar ? item.cancel_info.avatar : defaultImg" alt="" />
                                                                <span v-text="item.cancel_info.name"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="field_list_item">
                                                        <div class="field_name">取消日期：</div>
                                                        <div class="field_value">
                                                            <span v-text="item.cancel_at"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </template>
                            <!--表格-->
                            <template v-if="showType == 'table'">
                                <div class="inventory_pending_table">
                                    <el-table class="custom_table" :data="tableData" :height="tableHeight" border ref="tableContainer" row-key="id" >
                                        <el-table-column :label="tabNavActive == 'need' ? '待办' : tabNavActive == 'completed' ? '已完成' : '已取消'" prop="id" show-overflow-tooltip width="70px">
                                            <template #default="{ row }">
                                                <span v-text="row.type == 'in' ? '入库' : '出库'"></span>
                                            </template>
                                        </el-table-column>
                                        <template v-if="tabNavActive == 'need'">
                                            <el-table-column label="类型" prop="approval_set_name" show-overflow-tooltip width="128px" ></el-table-column>
                                            <el-table-column label="业务编号" prop="approval_id" show-overflow-tooltip width="158px" >
                                                <template #default="{ row }">
                                                    <span v-if="row.related_info && row.related_info.related_num" class="link-label" @click="handleClickRelatedDetail(row)" v-text="row.related_info.related_num"></span>
                                                    <span v-else>--</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="状态" prop="status" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="status_code" v-if="row.type =='in'">
                                                        <span class="status_code_text status_code0"  v-if="row.status == 0 ">待入库</span>
                                                        <span class="status_code_text status_code1"  v-if="row.status == 1 ">已取消</span>
                                                        <span class="status_code_text status_code2"  v-if="row.status == 2 ">部分入库</span>
                                                        <span class="status_code_text status_code3"  v-if="row.status == 3 ">全部入库</span>
                                                    </div>
                                                    <div class="status_code" v-else>
                                                        <span class="status_code_text status_code0"  v-if="row.status == 0 ">待出库</span>
                                                        <span class="status_code_text status_code1"  v-if="row.status == 1 ">已取消</span>
                                                        <span class="status_code_text status_code2"  v-if="row.status == 2 ">部分出库</span>
                                                        <span class="status_code_text status_code3"  v-if="row.status == 3 ">全部出库</span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="产品" prop="product" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="flexLeftAutoRight ellipsis tooltip_log_class" v-if="row.products && row.products.length>0">
                                                        <p  class="leftText ellipsis">
                                                            <span v-text="row.products[0]"></span>
                                                        </p>
                                                        <span  class="rightText" v-if="row.products.length > 1" v-text="'+'+ row.products.length"></span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="发起人" prop="creator_info" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="user_head" v-if="row.creator_info" @click="handleClickUserDetail(row.creator_info.id)">
                                                        <img :src="row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                                        <span v-text="row.creator_info.name"></span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="发起单据日期" prop="created_at" show-overflow-tooltip width="140px" ></el-table-column>
                                            <el-table-column label="操作" prop="handle" show-overflow-tooltip width="58px" fixed="right">
                                                <template #default="{ row }">
                                                    <el-button type="text" @click="handleClickPending(row)">审核</el-button>
                                                </template>
                                            </el-table-column>
                                        </template>

                                        <template v-if="tabNavActive == 'completed'">
                                            <el-table-column label="审批编号" prop="approval_id" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <span v-if="row.approval_id > 0" class="link-label" @click="handleClickApprovalDetail(row)" v-text="row.approval_id"></span>
                                                    <span v-else>--</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="编号" prop="log_num" show-overflow-tooltip width="150px" >
                                                <template #default="{ row }">
                                                    <span class="link-label" @click="handleClickDetail(row)" v-text="row.log_num"></span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="类型" prop="approval_set_name" show-overflow-tooltip width="128px" ></el-table-column>
                                            <el-table-column label="业务编号" prop="related_info" show-overflow-tooltip width="158px" >
                                                <template #default="{ row }">
                                                    <span v-if="row.related_info && row.related_info.related_num" class="link-label" @click="handleClickRelatedDetail(row)" v-text="row.related_info.related_num"></span>
                                                    <span v-else>--</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="产品" prop="product" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="flexLeftAutoRight ellipsis tooltip_log_class" v-if="row.log_products && row.log_products.length>0">
                                                        <p  class="leftText ellipsis">
                                                            <span v-text="row.log_products[0]"></span>
                                                        </p>
                                                        <span  class="rightText" v-if="row.log_products.length > 1" v-text="'+'+ row.log_products.length"></span>
                                                    </div>
                                                </template>
                                            </el-table-column>

                                            <el-table-column label="发起人" prop="approval_user" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="user_head" v-if="row.approval_user" @click="handleClickUserDetail(row.approval_user.id)">
                                                        <img :src="row.approval_user.avatar ? row.approval_user.avatar : defaultImg" alt="" />
                                                        <span v-text="row.approval_user.name"></span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="处理人" prop="creator_info" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="user_head" v-if="row.creator_info" @click="handleClickUserDetail(row.creator_info.id)">
                                                        <img :src="row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                                        <span v-text="row.creator_info.name"></span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="日期" prop="created_at" show-overflow-tooltip width="140px" ></el-table-column>

                                            <el-table-column label="操作" prop="handle" show-overflow-tooltip width="58px" fixed="right">
                                                <template #default="{ row }">
                                                    <el-button type="text" @click="handleClickDetail(row)">详情</el-button>
                                                </template>
                                            </el-table-column>
                                        </template>

                                        <template v-if="tabNavActive == 'cancelled'">
                                            <el-table-column label="审批编号" prop="approval_id" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <span v-if="row.approval_id > 0" class="link-label" @click="handleClickApprovalDetail(row)" v-text="row.approval_id"></span>
                                                    <span v-else>--</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="类型" prop="approval_set_name" show-overflow-tooltip width="128px" ></el-table-column>
                                            <el-table-column label="取消产品" prop="product" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="flexLeftAutoRight ellipsis tooltip_log_class" v-if="row.products && row.products.length>0">
                                                        <p  class="leftText ellipsis">
                                                            <span v-text="row.products[0]"></span>
                                                        </p>
                                                        <span  class="rightText" v-if="row.products.length > 1" v-text="'+'+ row.products.length"></span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="发起人" prop="creator_info" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="user_head" v-if="row.creator_info" @click="handleClickUserDetail(row.creator_info.id)">
                                                        <img :src="row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                                        <span v-text="row.creator_info.name"></span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="处理人" prop="cancel_info" show-overflow-tooltip width="128px" >
                                                <template #default="{ row }">
                                                    <div class="user_head" v-if="row.cancel_info" @click="handleClickUserDetail(row.cancel_info.id)">
                                                        <img :src="row.cancel_info.avatar ? row.cancel_info.avatar : defaultImg" alt="" />
                                                        <span v-text="row.cancel_info.name"></span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="取消日期" prop="cancel_at" show-overflow-tooltip width="140px" ></el-table-column>
                                            <el-table-column label="取消原因" prop="reason" show-overflow-tooltip width="128px" ></el-table-column>

                                            <el-table-column label="操作" prop="handle" show-overflow-tooltip width="58px" fixed="right">
                                                <template #default="{ row }">
                                                    <el-button @click="handleClickCancelDetail(row)" type="text">详情</el-button>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>
                                </div>

                            </template>
                        </div>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>

                    <!-- 排序-->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"  z-index="100" v-if="sortRadioPicker" :show="sortRadioPicker" @click="sortRadioPicker = false" >
                        <div class="custome_radio_option_wrap">
                            <ul class="radio_option_list">
                                <li v-for="item in sortList" class="radio_option_item"  @click="handleClickSortItem(item)"  v-text="item.name"></li>
                            </ul>
                            <div class="cancel_btn" @click="sortRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>
                    <!--筛选-->
                    <van-popup v-if="searchPopupShow"  v-model="searchPopupShow" :close-on-click-overlay="false"
                               :style="{ height: '60%',background:'#F7F8FA' }"  position="bottom"  @click-overlay="handleClickPopupClose"  round>
                        <div class="search_popup_header">
                            <div class="arrow_left_icon" >
                                <van-icon   name="arrow-left" @click="handleClickReturn"/>
                            </div>
                            <div class="title" v-text="searchPopupTitle"></div>
                            <div class="right_btn_wrap">
                                <span v-if="conditionShowType == ''"  class="clear_btn" @click="handleClickSearchClear">清空</span>
                                <span v-else class="confirm_btn" @click="handleClickSearchConfirm"></span>
                            </div>
                        </div>
                        <div class="search_popup_content">

                            <template v-if="conditionShowType == ''">
                                <div class="condition_field_list">
                                    <div class="condition_field_item" v-if="tabNavActive != 'need'">
                                        <van-field :label="tabNavActive == 'completed'  ? '已完成': '已取消'"   placeholder=""  readonly>
                                            <template #button>
                                                <van-checkbox-group v-model="inOutCheckbox" direction="horizontal" @change="handleChangeInOutCheckbox">
                                                    <van-checkbox shape="square" name="out">出库</van-checkbox>
                                                    <van-checkbox shape="square" name="in">入库</van-checkbox>
                                                </van-checkbox-group>
                                            </template>
                                        </van-field>

                                    </div>
                                    <div class="condition_field_item" v-for="item in searchFilterList">
                                        <div v-if="item.field_key == 'stock_id'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择仓库"  readonly></van-field>
                                        </div>
                                        <div v-if="item.field_key == 'stock_type'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择类型"  readonly></van-field>
                                        </div>
                                        <div v-if="item.field_key == 'status'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择状态"  readonly></van-field>
                                        </div>
                                        <div v-if="item.field_key == 'uid'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择发起人"  readonly></van-field>
                                        </div>
                                        <div v-if="item.field_key == 'handle_uid' || item.field_key == 'cancel_uid'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择处理人"  readonly></van-field>
                                        </div>
                                        <div v-if="item.field_key == 'date_range'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择发起单据日期"  readonly></van-field>
                                        </div>
                                        <div v-if="item.field_key == 'cancel_at'">
                                            <van-field  @click="handleClickSelectFilter(item)" clickable is-link :label="item.field_name" :value="item.field_value_name"   placeholder="请选择取消日期"  readonly></van-field>
                                        </div>
                                        <div v-if="item.field_key == 'reason'">
                                            <van-field v-model="item.field_value" rows="1"  autosize :label="item.field_name" type="textarea"  placeholder="请输入"/>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <ul class="condition_field_value_list" v-if="conditionShowType == 'status'">
                                    <li v-if="tabNavChildActive == 'all' || tabNavChildActive == 'in'" v-for="list in inStatusList" v-text="list.name" @click="handleClickSelectFilterValue(list)"></li>
                                    <li v-if="tabNavChildActive == 'all' || tabNavChildActive == 'out'" v-for="list in outStatusList" v-text="list.name" @click="handleClickSelectFilterValue(list)"></li>
                                </ul>
                                <ul class="condition_field_value_list" v-if="conditionShowType == 'stock_type'">
                                    <li v-if="tabNavChildActive == 'all'" class="bold_text">入库类型</li>
                                    <li v-if="tabNavChildActive == 'all' || tabNavChildActive == 'in'" v-for="list in inTypeList" v-text="list.name" @click="handleClickSelectFilterValue(list)"></li>
                                    <li v-if="tabNavChildActive == 'all'" class="bold_text">出库类型</li>
                                    <li v-if="tabNavChildActive == 'all' || tabNavChildActive == 'out'" v-for="list in outTypeList" v-text="list.name" @click="handleClickSelectFilterValue(list)"></li>
                                </ul>
                            </template>
                        </div>
                    </van-popup>
                    <!--选择仓库-->
                    <SelectStock  :selectStockPopupShow.sync="selectStockPopupShow" v-if="selectStockPopupShow" :selectedStockId="searchFilterList.find(item=>item.field_key == 'stock_id') ? searchFilterList.find(item=>item.field_key == 'stock_id').field_value : 0" @success="selectStockSuccess"/>
                    <!-- 人员选择 -->
                    <UserSearchSelect :userSelectVisible.sync="userSelectVisible"  :userSelectTitle="'选择人员'" :selectType="'one'" @selectUserData="handleSelectUserData" @selectUserClose="selectUserClose" v-if="userSelectVisible"/>
                    <van-popup v-model="calendarShow" :close-on-click-overlay="true"  :style="{ height: '70vh',background:'#F7F8FA' }"  position="bottom"  round  @click-overlay="handleClickPopupRangeCalendarClose">
                       <van-calendar  :allow-same-day="true" :max-date="dateCalendarMax" :min-date="dateCalendarMin" :default-date="defaultDate"	 :poppable="false"
                                      :show-confirm="true" :show-title="false"  color="#1990FF" type="range" @confirm="handleClickRangeCalendarConfirm"></van-calendar>

                   </van-popup>

                    <userDetailDialog  v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow"  :userId="userDetailId" />

                </div>
            </template>
        </PullContainer>
    </div>

</template>
<script>
import {getStockLogList,getPendingList,getPendingCancelList,getStockType} from "@/api";
import {formatDate} from "@/utils";
import PullContainer from '@/components/mComponents/PullContainer.vue'
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from '@/components/mComponents/FooterTabbar.vue'
import SelectStock from "./component/select_stock"
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import { pagination } from "@/mixins";

export default {
    name: 'InventoryPending',
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        SelectStock,
        UserSearchSelect,
        userDetailDialog
    },
    data () {
        return {
            loading:false,
            defaultImg: require("@/assets/images/default.jpg"),
            showType:'card',
            tabBarList:[
                {
                    icon:'icon-shouye',
                    activeIcon:'icon-shouyexuanzhong',
                    routerName:'InventoryManagement',
                    title:'首页'
                },
                {
                    icon:'icon-cangku2',
                    activeIcon:'icon-cangkuxuanzhong',
                    routerName:'WarehouseManagement',
                    title:'仓库管理'
                },
                {
                    icon:'icon-renwu_weixuanzhong',
                    activeIcon:'icon-renwu_xuanzhong',
                    routerName:'InventoryPending',
                    title:'出入库待办'
                },
            ],
            tabBarActive:2,
            tab_nav_list:[
                {name:'待办',value:'need'},
                {name:'已完成',value:'completed'},
                {name:'已取消',value:'cancelled'},
            ],
            tabNavActive:'need',
            tabNavChildActive:'all',
            inOutCheckbox:[],
            headOperatePopoverShow: false,
            headOperateActionsList: [
                { text: "出库", icon: "iconfont icon-chuku" },
                { text: "入库", icon: "iconfont icon-ruku" },
                { text: "扫一扫", icon: "iconfont icon-saoyisao" },
            ],
            searchForm:{
                keyword:'',
                sort:'desc'
            },
            sortRadioPicker:false,
            sortList:[
                {name:'升序排序',value:'asc'},
                {name:'降序排序',value:'desc'},
            ],
            searchPopupShow:false,
            searchPopupTitle:'',
            searchFilterList:[],
            pendingSearchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '类型',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'status',
                    field_name: '状态',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'uid',
                    field_name: '发起人',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'date_range',
                    field_name: '发起单据日期',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
            ],
            alreadySearchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '类型',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'stock_id',
                    field_name: '仓库',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'uid',
                    field_name: '发起人',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'handle_uid',
                    field_name: '处理人',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'date_range',
                    field_name: '发起单据日期',
                    field_value: [],
                    field_value_name: '',
                    field_type: 'eq',
                },
            ],
            cancelSearchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '类型',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'uid',
                    field_name: '发起人',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'cancel_uid',
                    field_name: '处理人',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'cancel_at',
                    field_name: '取消日期',
                    field_value: [],
                    field_value_name: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'reason',
                    field_name: '取消原因',
                    field_value: '',
                    field_value_name: '',
                    field_type: 'eq',
                },
            ],


            inStatusList:[
                {value:'0',name:'待入库'},
                {value:'2',name:'部分入库'},

            ],
            outStatusList:[
                {value:'0',name:'待出库'},
                {value:'2',name:'部分出库'},
            ],
            conditionShowType:'',
            selectStockPopupShow:false,
            userSelectVisible:false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
            calendarShow:false,
            defaultDate:[],

            tableData:[ ],
            tableHeight:'',
            inTypeList:[],
            outTypeList:[],
            userDetailPopupShow:false,
            userDetailId: 0,
        }
    },
    mixins: [pagination],
    created() {
        this.$nextTick(()=>{
            this.tableHeight = this.$refs.inventory_pending_bottom ? this.$refs.inventory_pending_bottom.offsetHeight - 20 : 455
        })
        this.searchFilterList = JSON.parse(JSON.stringify(this.pendingSearchFilterList))
    },
    mounted () {
        this.getInTypeList()
        this.getTableData()
    },
    methods: {
        pullDownLoadingSuccess(flag){
            if(flag){
                setTimeout(()=>{
                    this.$refs.pullContainerRef.pullDownLoadingEnd()
                },3000)
            }
        },
        handleClickHeadOperate(item) {
            this.headOperatePopoverShow = false;
        },

        // 选择筛选
        handleClickSelectFilter(item){
            this.conditionShowType = item.field_key
            if(item.field_key == 'stock_id'){
                this.selectStockPopupShow = true
                this.conditionShowType = ''
            }else if(item.field_key == 'stock_type'){

            }else if(item.field_key == 'status'){

            }else if(item.field_key == 'uid'){
                this.userSelectVisible = true
            }else if(item.field_key == 'handle_uid') {
                this.userSelectVisible = true
            }else if(item.field_key == 'date_range'){
                this.calendarShow = true
            }else if(item.field_key == 'cancel_at'){
                this.calendarShow = true
            }

        },
        // 选择仓库回调
        selectStockSuccess(data){
            this.searchFilterList.find(find =>find.field_key == 'stock_id').field_value = data.id
            this.searchFilterList.find(find =>find.field_key == 'stock_id').field_value_name = data.name
            this.conditionShowType = ''
        },
        // 选择人员回调
        handleSelectUserData(data){
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value = data.uid
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value_name = data.name
            this.conditionShowType = ''
        },
        // 选择人员取消回调
        selectUserClose(){
            this.conditionShowType = ''
        },
        // 选择日期
        handleClickRangeCalendarConfirm(range){
            const [start, end] = range
            let value = [formatDate(start, 'date'), formatDate(end, 'date')]
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value = value
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value_name = value.join(' - ')
            this.calendarShow = false
            this.conditionShowType = ''
        },
        // 取消选择日期
        handleClickPopupRangeCalendarClose(){
            this.conditionShowType = ''
        },
        // 选择状态
        handleClickSelectFilterValue(list){
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value = list.value
            this.searchFilterList.find(find => find.field_key == this.conditionShowType).field_value_name = list.name
            this.calendarShow = false
            this.conditionShowType = ''
        },
        // 切换展现方式
        handleClickShowType(type){
            this.showType = type
            if(type == 'table'){
                this.$nextTick(()=>{
                    const container = this.$refs.tableContainer.$el.querySelector('.el-table__body-wrapper'); // 获取 el-table 的根 DOM 元素
                    if (container) {
                        container.addEventListener('scroll', this.handleScroll);
                    }
                })
            }
        },
        handleScroll() {
            const container = this.$refs.tableContainer.$el.querySelector('.el-table__body-wrapper');
            if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                this.onLoadList();
            }
        },
        // 加载更多
        onLoadList() {
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        // 筛选
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.tableData = []
            this.getTableData()
        },
        // 排序
        handleClickSortItem(item){
            this.searchForm.sort = item.value
            this.sortRadioPicker = false
            this.handleClickSearch()
        },
        // 关闭筛选弹出
        handleClickPopupClose(){
            this.searchPopupShow = false
            this.handleClickSearch()
        },
        // 筛选返回上一步
        handleClickReturn(){
            if(this.conditionShowType){
                this.conditionShowType = ''
            }else{
                this.searchPopupShow = false
                this.handleClickSearch()
            }
        },
        // 筛选清空
        handleClickSearchClear(){
            this.searchFilterList.forEach((item)=>{
                item.field_value = ''
                item.field_value_name = ''
            })
            this.handleClickSearch()
        },
        // 筛选确定
        handleClickSearchConfirm(){
            this.handleClickSearch()
        },
        // 选择tab
        handleClickTabNav(item){
            // {name:'待办',value:'need'},
            // {name:'已完成',value:'completed'},
            // {name:'已取消',value:'cancelled'},
            if(this.tabNavActive == 'need'){
                this.pendingSearchFilterList = JSON.parse(JSON.stringify(this.searchFilterList))
            }else if(this.tabNavActive == 'completed'){
                this.alreadySearchFilterList = JSON.parse(JSON.stringify(this.searchFilterList))
            }else if(this.tabNavActive == 'cancelled'){
                this.cancelSearchFilterList = JSON.parse(JSON.stringify(this.searchFilterList))
            }
           if(item.value == 'need'){
               this.searchFilterList = JSON.parse(JSON.stringify(this.pendingSearchFilterList))
           } else if(item.value == 'completed'){
               this.searchFilterList = JSON.parse(JSON.stringify(this.alreadySearchFilterList))
           }else if(item.value == 'cancelled'){
               this.searchFilterList = JSON.parse(JSON.stringify(this.cancelSearchFilterList))
           }


          this.tabNavActive = item.value
          this.tabNavChildActive = 'all'
          this.$nextTick(()=>{
              this.tableHeight = this.$refs.inventory_pending_bottom ? this.$refs.inventory_pending_bottom.offsetHeight - 20 : 455
          })
          this.handleClickSearch()
        },
        // 已完成、已取消时筛选出库入库
        handleChangeInOutCheckbox(value){
            if(value.length == 2 || value.length == 0){
                this.tabNavChildActive = 'all'
            }else{
                if(value.indexOf('in') > -1){
                    this.tabNavChildActive = 'in'
                }else if(value.indexOf('out') > -1){
                    this.tabNavChildActive = 'out'
                }
            }
            this.searchFilterList.forEach((item)=>{
                if(item.field_key == 'stock_type'){
                    item.field_value = '';
                    item.field_value_name = ''
                }
            })
        },

        handleClickTabNavChild(type){
            this.tabNavChildActive = type
            this.handleClickSearchClear()
        },
        getInTypeList(){
            getStockType({ type:'in'}).then((res) => {
                if (res.code == 200) {
                    this.inTypeList = res.data.map(map => {
                        return {
                            value:map.stock_type,
                            name:map.stock_type_name
                        }
                    }) || [];
                }
            });
            getStockType({ type:'out'}).then((res) => {
                if (res.code == 200) {
                    this.outTypeList = res.data.map(map => {
                        return {
                            value:map.stock_type,
                            name:map.stock_type_name
                        }
                    }) || [];
                }
            });
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize:this.pagination.pageSize,
                keyword:this.searchForm.keyword,
                sort:this.searchForm.sort,
                type:this.tabNavChildActive == 'all' ? '' : this.tabNavChildActive
            }
            this.searchFilterList.forEach((item)=>{
                if(item.field_key == 'date_range' || item.field_key == 'cancel_at'){
                    if(item.field_value && item.field_value.length>0){
                        let startDate = item.field_value[0] + ' 00:00'
                        let endDate = item.field_value[1] + ' 23:59'
                        postData[item.field_key] = startDate + ' - ' + endDate
                    }else{
                        postData[item.field_key] = ''
                    }
                }else{
                    postData[item.field_key] = item.field_value
                }
            })
            if(this.tabNavActive == 'need'){ // 待办
                getPendingList(postData).then(res => {
                    if (res.code === 200) {
                        let {list,total} = res.data
                        this.tableData = this.tableData.concat(list)
                        this.pagination.total = total
                        this.pagination.pageNum++;
                        this.loading = false
                        if(this.pullDownLoading){
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');
                        }
                    }
                })
            }else if(this.tabNavActive == 'completed'){ //已完成
                getStockLogList(postData).then(res => {
                    if (res.code === 200) {
                        let {list,total} = res.data
                        this.tableData = this.tableData.concat(list)
                        this.pagination.total = total
                        this.pagination.pageNum++;
                        this.loading = false
                        if(this.pullDownLoading){
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');
                        }
                    }
                })
            }else if(this.tabNavActive == 'cancelled'){ //已取消
                getPendingCancelList(postData).then(res => {
                    if (res.code === 200) {
                        let {list,total} = res.data
                        this.tableData = this.tableData.concat(list)
                        this.pagination.total = total
                        this.pagination.pageNum++;
                        this.loading = false
                        if(this.pullDownLoading){
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');
                        }
                    }
                })
            }


        },
        handleClickUserDetail(uid){
            this.userDetailId = uid
            this.userDetailPopupShow = true
        },
        // 待办
        handleClickPending(item){
            if(item.type == 'in'){
                this.$router.push({
                    name: 'InWarehouseAudit',
                    query:{
                        stock_pending_id:item.stock_pending_id,
                        name:item.approval_set_name
                    },
                    params: {
                        isPush: true
                    }
                })
            }else{
                this.$router.push({
                    name: 'OutWarehouseAudit',
                    query:{
                        stock_pending_id:item.stock_pending_id,
                        name:item.approval_set_name
                    },
                    params: {
                        isPush: true
                    }
                })
            }
        },
        // 取消详情
        handleClickCancelDetail(row){

        },
        // 查看详情
        handleClickDetail(row){
            if(row.type == 'in'){
                this.$router.push({
                    name: "InProductDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        id:row.id,
                    },
                });
            }else{
                this.$router.push({
                    name: "OutProductDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        id:row.id,
                    },
                });
            }
        },

        // 审批详情
        handleClickApprovalDetail(row) {
            this.$showApprovalDetail({
                approval_id: row.approval_id,
            }).then((res) => {
                console.log(res);
            });
        },
        // 关联详情
        handleClickRelatedDetail(row){
            if(row.related_info.related_type == 'purchase'){
                this.$router.push({
                    name:'purchaseDetail',
                    query:{
                        purchase_id:row.related_info.related_id
                    }
                })
            }else if(row.related_info.related_type == 'order'){
                this.$router.push({
                    name: "OrderDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        order_id:row.related_info.related_id,
                        name:row.related_info.related_num,
                    },
                });
            }
        },

    },

}
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/inventory_management.scss";
</style>
